module.exports = __webpack_public_path__ + "static/img/05.39d7c36c.png";